import { createContext } from 'react';

export type Device = 'desktop' | 'tablet' | 'mobile';
export const MediaQueryContext = createContext<Device | undefined>(undefined);
